import React, { useState } from "react";
import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
  Card,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AgeCalculation from "./ageCalculation";
import { Directions } from "@mui/icons-material";
import Logo from "../../asset/Logo.jpg";

function LoadingModal(props) {
  const [open, setOpen] = useState(true);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDateDay: "",
    birthDateMonth: "",
    birthDateYear: "",
    relation: "",
  });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log(props.submitedData);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100vw",
    height: "100vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "scroll",
  };

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  console.log(formData);

  var today = new Date();
  var validDateEnd = new Date(new Date().setDate(today.getDate() + 30));
  console.log(validDateEnd);
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          {props.submitedData.status === "waiting" && (
            <Stack
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="100%"
            >
              <CircularProgress />

              <>Submitting waiver....</>
            </Stack>
          )}

          {props.submitedData.status === "success" && (
            <Stack
              alignItems="center"
              //   justifyContent="center"
              width="100%"
              height="100%"
              sx={{ overflowY: "auto" }}
            >
              <Box
                sx={{
                  width: "280px",
                  // color: "white",
                  fontSize: "20px",
                  // backgroundColor: "green",
                  padding: "5px",
                  marginTop: "100px",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                Waiver Completed. Thank you!
              </Box>

              <Box
                sx={{
                  //   fontSize: "12px",
                  width: "280px",
                  textAlign: "left",
                  marginTop: "5px",
                  color: "gray",
                }}
              >
                You may take a <b>screenshot</b> of the waiver card below to
                avoid re-signing the waiver and speed up your check-in.
              </Box>
              <Card
                sx={{
                  marginTop: "20px",
                  padding: "5px",
                  boxShadow: 4,
                }}
              >
                <Stack alignItems="center" justifyContent="center">
                  <img src={Logo} alt={"logo"} style={{ height: "70px" }} />
                  <Box
                    sx={{
                      width: "fit-content",
                      textAlign: "center",
                      paddingBottom: "20px",
                      color: "#9b13b9",
                      fontSize: "18px",
                    }}
                  >
                    Candyland Waiver Card
                  </Box>

                  <Stack alignContent={"start"} width="250px">
                    {/* Signed on: {props.submitedData.data.timeStamp.slice(0, 10)} */}
                  </Stack>
                  <Stack
                    width="250px"
                    alignItems="center"
                    sx={{
                      width: " fit-content",
                      border: "1px green solid",
                      borderRadius: "10px",
                      backgroundColor: "green",
                      padding: "5px",
                      color: "white",
                    }}
                  >
                    Effective until {validDateEnd.toLocaleDateString()}
                  </Stack>
                  <Stack
                    alignItems="center"
                    justifyContent="start"
                    width="280px"
                    paddingTop="30px"
                  >
                    <Box
                      sx={{
                        color: "purple",
                        fontSize: "15px",
                        width: "280px",
                        textAlign: "left",
                        marginBottom: "5px",
                        paddingLeft: "15px",
                      }}
                    >
                      Adult
                    </Box>

                    <Box
                      sx={{
                        width: "280px",
                        textAlign: "left",
                        paddingLeft: "15px",
                      }}
                    >
                      {props.submitedData.data.firstName}{" "}
                      {props.submitedData.data.lastName}
                    </Box>

                    <Box
                      sx={{
                        color: "purple",
                        fontSize: "15px",
                        width: "280px",
                        textAlign: "left",
                        // borderTop: "1px gray solid",
                        paddingLeft: "15px",

                        paddingTop: "25px",
                        marginBottom: "5px",
                      }}
                    >
                      Minor(s)
                    </Box>
                  </Stack>
                  {props.submitedData.data.minors.length > 0 ? (
                    props.submitedData.data.minors.map((e) => (
                      <>
                        <Box
                          sx={{
                            width: "280px",
                            textAlign: "left",
                            paddingLeft: "15px",
                          }}
                        >
                          {e.firstName} {e.lastName} (
                          <AgeCalculation
                            birthDate={`${e.birthDateYear}-${e.birthDateMonth}-${e.birthDateDay} 10:45:31.123Z`}
                          />
                          )
                        </Box>

                        <Box
                          sx={{
                            fontSize: "20px",
                            width: "280px",
                            textAlign: "right",
                          }}
                        ></Box>

                        <Box
                          sx={{
                            color: "purple",
                            fontSize: "20px",
                            width: "280px",
                            textAlign: "left",
                            // borderTop: "1px black solid",
                            paddingTop: "30px",
                          }}
                        ></Box>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </Stack>
              </Card>
            </Stack>
          )}

          {/* {props.submittedData.status="success":} */}
        </Box>
      </Modal>
    </div>
  );
}

export default LoadingModal;
